module.exports = __webpack_public_path__ + "static/media/sf.6a0203b0.svg";